import React, { useEffect, useMemo, useRef, useState } from "react";
import AAC from "../Components/Assets/AAC Blocks.jpg";
import Chemical from "../Components/Assets/Chemical.jpg";
import Construction from "../Components/Assets/Construction.jpg";
import LeftAdv1 from "../Components/Assets/Advertise/AdvertiseHerePost1.jpg";
import LeftAdv2 from "../Components/Assets/Advertise/AdvertiseHerePost2.jpg";
import LeftAdv3 from "../Components/Assets/Advertise/AdvertiseHerePost3.jpg";
import GFRP from "../Components/Assets/GFRP.jpg";
import Formwork from "../Components/Assets/Formwork.jpg";
import Light from "../Components/Assets/Light.jpg";
import Safety from "../Components/Assets/Safety.jpg";
import Cement from "../Components/Assets/Steel1.jpeg";
import Steel from "../Components/Assets/Cement1.jpeg";

import axiosInstance from "./axiosInstance";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../config/url";
import { Helmet } from "react-helmet-async";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import CategoryStrip from "../Components/CategoryStrip";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Onexvideo = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [productBox2, setProductBox2] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingSubcats, setIsLoadingSubcats] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  // track active slide for left advert (for moving heading)
  const [activeAdvertIndex, setActiveAdvertIndex] = useState(0);

  const navigate = useNavigate();
  const catTrackRef = useRef(null);

  // detect prefers-reduced-motion
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mq.matches);
    const handler = (e) => setPrefersReducedMotion(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  // Middle hero slides
  const imageSlides = useMemo(
    () => [
      {
        src: AAC,
        alt:
          "AAC blocks 600×200×200 mm—lightweight, fire resistant, thermally insulated construction blocks suitable for walls and partitions.",
      },
      {
        src: Chemical,
        alt:
          "Construction chemicals—admixture, curing compound, grout, tile adhesive, and waterproofing solutions for concrete durability.",
      },
      {
        src: Construction,
        alt:
          "Chemical and mechanical anchors for concrete—high load capacity fastening systems for structural reliability.",
      },
      {
        src: GFRP,
        alt:
          "GFRP rebar—corrosion resistant glass-fiber reinforced polymer bars with high tensile strength for coastal and aggressive environments.",
      },
      {
        src: Formwork,
        alt:
          "Mivan shuttering and cuplock formwork—modular systems for fast and safe casting of slabs, columns, and walls.",
      },
      {
        src: Light,
        alt:
          "LED industrial and site lighting—energy-efficient luminaires offering up to 80% power saving for projects.",
      },
      {
        src: Safety,
        alt:
          "Construction safety PPE—helmets, harnesses, gloves, safety shoes, jackets, goggles, masks, nets, and fire extinguishers.",
      },
      {
        src: Cement,
        alt:
          "UltraTech Cement bags and Cement Bulker unloading at a construction site – premium building material supplier in Navi Mumbai And Allover India..",
      },
      {
        src: Steel,
        alt:
          "Steel products including TMT steel bars, binding wire, and steel billets for infrastructure projects, residential buildings, and commercial complexes.",
      },
    ],
    []
  );

  // LEFT advertise slider slides (with titles + links)
  const advertSlides = useMemo(
    () => [
      {
        src: LeftAdv1,
        title: "Growmax-OGCS Advertisement",
        alt: "BuildPro-OGCS advertise here banner 1",
        link: "https://growmax.ogcs.co.in/",
      },
      {
        src: LeftAdv2,
        title: "OGCS Expert Consultancy Advertisement",
        alt: "BuildPro-OGCS advertise here banner 2",
        link: "https://ogcsexpertconsultancy.ogcs.co.in/",
      },
      {
        src: LeftAdv3,
        title: "Advertise here",
        alt: "BuildPro-OGCS advertise here banner 3",
        link: "https://buildpro.ogcs.co.in/",
      },
    ],
    []
  );

  const fetchData = async (url, setter) => {
    try {
      const { data } = await axiosInstance.get(url);
      setter(Array.isArray(data) ? data : data ?? []);
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
      setter([]);
    }
  };

  // initial load
  useEffect(() => {
    let mounted = true;

    (async () => {
      setIsLoading(true);
      try {
        const { data } = await axiosInstance.get(
          `${baseurl}/api/category/get-all`
        );
        if (mounted) {
          setCategories(Array.isArray(data) ? data : data ?? []);
        }
      } catch (e) {
        console.error(e);
        if (mounted) setCategories([]);
      } finally {
        if (mounted) setIsLoading(false);
      }

      // PowerPack box2
      fetchData(`${baseurl}/api/seller/products/box2`, (v) => {
        if (mounted) setProductBox2(v);
      });
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const handleCategoryClick = async (categoryId) => {
    if (selectedCategoryId === categoryId) {
      setSelectedCategoryId(null);
      setSubcategories([]);
      return;
    }

    setSelectedCategoryId(categoryId);
    setIsLoadingSubcats(true);

    try {
      const { data } = await axiosInstance.get(
        `${baseurl}/api/subcategory/category/${categoryId}`
      );
      setSubcategories(Array.isArray(data) ? data : data ?? []);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      setSubcategories([]);
    } finally {
      setIsLoadingSubcats(false);
    }
  };

  const handleImageClick = (subcategoryId, categoryname) => {
    navigate(`/products/${subcategoryId}`, { state: { categoryname } });
  };

  const handleImageClickPowerPack = (productId) => {
    navigate(`/product/details/${productId}`);
  };

  const formatINR = (n) =>
    typeof n === "number"
      ? new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 0,
        }).format(n)
      : n;

  const pageTitle = "BuildPro-OGCS | Building Supplies at Your Fingertips";
  const pageDescription =
    "Buy construction materials online: AAC blocks, GFRP rebar, cement, TMT steel, chemicals, formwork, lighting, and PPE. Explore categories and PowerPack highlights on BuildPro-OGCS.";

  const itemListJsonLd =
    productBox2?.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: productBox2.slice(0, 10).map((p, idx) => ({
            "@type": "ListItem",
            position: idx + 1,
            item: {
              "@type": "Product",
              name: p?.name,
              image: p?.image
                ? `data:${p.image?.contentType};base64,${p.image?.data}`
                : undefined,
              offers:
                typeof p?.price === "number"
                  ? {
                      "@type": "Offer",
                      priceCurrency: "INR",
                      price: String(p.price),
                      availability: "https://schema.org/InStock",
                    }
                  : undefined,
              url:
                typeof window !== "undefined"
                  ? `${window.location.origin}/product/details/${p?._id}`
                  : undefined,
            },
          })),
        }
      : null;

  // common slider height for all 3 sections
  const sliderHeightClass =
    "h-[220px] xs:h-[250px] sm:h-[290px] lg:h-[330px]";

  // Swiper classes WITH navigation (middle + right)
  const swiperControlClasses = `
    h-full w-full
    [&_.swiper-button-prev]:w-7
    [&_.swiper-button-prev]:h-7
    [&_.swiper-button-next]:w-7
    [&_.swiper-button-next]:h-7
    [&_.swiper-button-prev]:rounded-full
    [&_.swiper-button-next]:rounded-full
    [&_.swiper-button-prev]:bg-slate-900/10
    [&_.swiper-button-next]:bg-slate-900/10
    [&_.swiper-button-prev:hover]:bg-slate-900/20
    [&_.swiper-button-next:hover]:bg-slate-900/20
    [&_.swiper-button-prev::after]:text-[14px]
    [&_.swiper-button-next::after]:text-[14px]
    [&_.swiper-pagination]:!bottom-1
    [&_.swiper-pagination-bullet]:!bg-slate-300
    [&_.swiper-pagination-bullet-active]:!bg-sky-600
    [&_.swiper-pagination-bullet]:!opacity-100
  `;

  // Swiper classes WITHOUT navigation (left Advertisement – dots only)
  const swiperControlNoNavClasses = `
    h-full w-full
    [&_.swiper-pagination]:!bottom-1
    [&_.swiper-pagination-bullet]:!bg-slate-300
    [&_.swiper-pagination-bullet-active]:!bg-sky-600
    [&_.swiper-pagination-bullet]:!opacity-100
  `;

  const currentAdvert = advertSlides[activeAdvertIndex] || advertSlides[0];

  return (
    <section className="bg-blue-50 px-3 sm:px-6 " role="region">
      {/* SEO */}
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta
          name="robots"
          content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
        />
        <link
          rel="canonical"
          href={
            typeof window !== "undefined"
              ? `${window.location.origin}${window.location.pathname}`
              : "https://buildpro.ogcs.co.in/"
          }
        />
        <link rel="preload" as="image" href={imageSlides[0].src} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="BuildPro-OGCS" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={imageSlides[0].src} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={imageSlides[0].src} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "BuildPro-OGCS Home Highlights",
            description: pageDescription,
            publisher: {
              "@type": "Organization",
              name: "OGCS Private Limited",
              url: "https://ogcs.co.in",
            },
            primaryImageOfPage: imageSlides[0].src,
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item:
                    typeof window !== "undefined"
                      ? `${window.location.origin}/`
                      : "https://buildpro.ogcs.co.in/",
                },
              ],
            },
          })}
        </script>
        {itemListJsonLd && (
          <script type="application/ld+json">
            {JSON.stringify(itemListJsonLd)}
          </script>
        )}
      </Helmet>

      {/*================================================================================== categories */}
      <CategoryStrip
        categories={categories}
        isLoading={isLoading}
        selectedCategoryId={selectedCategoryId}
        onCategoryClick={handleCategoryClick}
      />

      {/* subcategories */}
      <div className="mt-1">
        {isLoadingSubcats ? (
          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3"
            aria-hidden="true"
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="bg-white rounded-xl shadow-sm border border-sky-100 p-3"
              >
                <div className="relative w-full overflow-hidden rounded-lg bg-sky-100/60">
                  <div className="pb-[66%] w-full" />
                </div>
                <div className="h-4 bg-sky-100/70 rounded mt-3 w-2/3 animate-pulse" />
              </div>
            ))}
          </div>
        ) : subcategories.length > 0 ? (
          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3"
            aria-label="Subcategories grid"
          >
            {subcategories.map((subcategory) => (
              <button
                key={subcategory._id}
                onClick={() =>
                  handleImageClick(subcategory._id, subcategory.name)
                }
                className="group bg-white rounded-xl shadow-sm border border-sky-100 overflow-hidden text-left transition hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sky-400"
                aria-label={`Open ${subcategory.name} products`}
              >
                <div className="relative w-full overflow-hidden">
                  <div className="pb-[75%] sm:pb-[66%] w-full" />
                  {subcategory.image ? (
                    <img
                      src={`${baseurl}${subcategory.image}`}
                      alt={`${subcategory.name} subcategory`}
                      className="absolute inset-0 w-full h-full object-contain bg-slate-100"
                      loading="lazy"
                      decoding="async"
                      width={320}
                      height={213}
                      sizes="(max-width: 640px) 45vw, (max-width: 1024px) 30vw, 16vw"
                      onError={(e) => {
                        e.currentTarget.src =
                          "data:image/svg+xml;charset=UTF-8," +
                          encodeURIComponent(
                            `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='266'><rect width='100%' height='100%' fill='#e2e8f0'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#64748b' font-family='Arial' font-size='14'>Image unavailable</text></svg>`
                          );
                      }}
                    />
                  ) : (
                    <div className="absolute inset-0 bg-sky-100/60 flex items-center justify-center text-sky-400 text-sm">
                      No image
                    </div>
                  )}
                </div>
                <div className="p-3">
                  <p className="text-sm font-semibold text-sky-900 line-clamp-1 min-h-[1.5rem]">
                    {subcategory.name}
                  </p>
                </div>
              </button>
            ))}
          </div>
        ) : selectedCategoryId ? (
          <p className="text-center text-sky-700 text-sm">
            No subcategories found.
          </p>
        ) : null}
      </div>

      {/* main 3-section layout: 25% / 50% / 25% on lg */}
      <div className="mt-3 grid gap-3 lg:grid-cols-4">
        {/* LEFT: Advert slider */}
        <aside className="bg-white border border-sky-100  rounded-2xl overflow-hidden lg:col-span-1">
          {/* Heading on top – moves & clicks with slider */}
          <div className="px-4 py-3 border-b border-sky-100 flex items-center justify-between bg-gradient-to-r from-sky-50 to-sky-100">
            <div className="flex flex-col gap-0.5">
              <p className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.18em] text-sky-500">
                Advertise Here
              </p>

              {currentAdvert?.link ? (
                <a
                  href={currentAdvert.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm sm:text-base font-semibold text-sky-900 line-clamp-2 hover:underline decoration-sky-500 whitespace-nowrap"
                >
                  {currentAdvert.title ?? "Advertise Your Brand"}
                </a>
              ) : (
                <h3 className="text-sm sm:text-base font-semibold text-sky-900 line-clamp-2">
                  {currentAdvert?.title ?? "Advertise Your Brand"}
                </h3>
              )}
            </div>
            <span className="hidden sm:inline-block text-[11px] text-sky-500">
              {activeAdvertIndex + 1}/{advertSlides.length}
            </span>
          </div>

          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={
              prefersReducedMotion
                ? false
                : {
                    delay: 4500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }
            }
            loop={advertSlides.length > 1}
            pagination={{ clickable: true }}
            className={`${sliderHeightClass} ${swiperControlNoNavClasses}`}
            aria-label="Advertisement carousel"
            onSwiper={(swiper) => {
              // ensure initial heading sync
              const idx =
                typeof swiper.realIndex === "number"
                  ? swiper.realIndex
                  : swiper.activeIndex ?? 0;
              setActiveAdvertIndex(idx);
            }}
            onSlideChange={(swiper) => {
              const idx =
                typeof swiper.realIndex === "number"
                  ? swiper.realIndex
                  : swiper.activeIndex ?? 0;
              setActiveAdvertIndex(idx);
            }}
          >
            {advertSlides.map((slide, index) => (
              <SwiperSlide key={index}>
                <a
                  href={slide.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full h-full"
                >
                  <div className="relative w-full h-full bg-slate-100 cursor-pointer">
                    {/* responsive image – keeps aspect ratio, no weird cropping */}
                    <img
                      src={slide.src}
                      alt={slide.alt || slide.title || "Advert banner"}
                      className="w-full h-[84%] sm:h-full object-contain select-none"
                      loading="lazy"
                      decoding="async"
                      width={800}
                      height={800}
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                    />
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </aside>

        {/* MIDDLE: Hero slider (50%) */}
        <div className="bg-white border border-sky-100 shadow-sm rounded-2xl overflow-hidden lg:col-span-2">
          <div className="bg-[#EFF6FF] px-4 py-3 border-b border-sky-100 flex items-center justify-between">
            <h3 className="text-base sm:text-lg font-semibold text-sky-900">
              Featured Construction Highlights
            </h3>
            <span className="hidden sm:inline-block text-xs text-sky-500">
              Swipe to explore materials
            </span>
          </div>
          <div className={sliderHeightClass}>
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              autoplay={
                prefersReducedMotion
                  ? false
                  : {
                      delay: 3000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }
              }
              loop
              navigation
              pagination={{ clickable: true }}
              className={swiperControlClasses}
              aria-label="Highlights carousel"
            >
              {imageSlides.map((slide, index) => (
                <SwiperSlide key={index} className="bg-slate-100">
                  <img
                    src={slide.src}
                    alt={slide.alt}
                    className="w-full h-full object-contain select-none"
                    draggable="false"
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : "low"}
                    decoding="async"
                    width={1280}
                    height={720}
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 100vw, 66vw"
                    onError={(e) => {
                      e.currentTarget.src =
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(
                          `<svg xmlns='http://www.w3.org/2000/svg' width='1280' height='720'><rect width='100%' height='100%' fill='#0b1220'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#94a3b8' font-family='Arial' font-size='16'>Image unavailable</text></svg>`
                        );
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* RIGHT: PowerPack Products slider */}
        <div
          className="bg-white border border-sky-100 shadow-sm rounded-2xl overflow-hidden lg:col-span-1"
          role="region"
          aria-label="PowerPack products"
        >
          <div className="px-4 py-3 border-b border-sky-100 flex items-center justify-between bg-gradient-to-r from-sky-50 to-sky-100">
            <div className="flex items-center gap-2">
              <h3 className="text-base sm:text-lg font-semibold text-sky-900">
                PowerPack Products
              </h3>
            </div>
            {productBox2.length > 0 && (
              <span className="text-[11px] text-sky-600 font-medium">
                {productBox2.length} items
              </span>
            )}
          </div>

          <div className={sliderHeightClass}>
            {productBox2.length > 0 ? (
              <Swiper
                key={`pp-${productBox2.length}`}
                modules={[Autoplay, Navigation, Pagination]}
                autoplay={
                  !prefersReducedMotion && productBox2.length > 1
                    ? {
                        delay: 6000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }
                    : false
                }
                loop={productBox2.length > 1}
                navigation
                pagination={{ clickable: true }}
                slidesPerView={1}
                className={swiperControlClasses}
                aria-label="PowerPack products carousel"
              >
                {[...productBox2].reverse().map((product) => (
                  <SwiperSlide
                    key={product._id}
                    className="px-3 py-3 h-full"
                  >
                    <div
                      onClick={() => handleImageClickPowerPack(product._id)}
                      className="h-full w-full cursor-pointer rounded-2xl flex flex-col gap-2 p-0 transition hover:-translate-y-[1px]"
                    >
                      {/* badges + price */}
                      <div className="flex items-center justify-between gap-2">
                        <span className="inline-flex items-center rounded-full bg-sky-100 text-sky-800 text-[11px] font-semibold px-2 py-0.5">
                          PowerPack
                        </span>
                        {product?.price != null && (
                          <span className="inline-flex items-center rounded-full bg-emerald-50 text-emerald-700 text-[11px] font-semibold px-2 py-0.5">
                            {formatINR(product.price)}
                          </span>
                        )}
                      </div>

                      {/* IMAGE */}
                      <div className="mt-1 bg-white/80 rounded-xl overflow-hidden flex-1 min-h-[200px] max-h-[270px] flex items-center justify-center">
                        <img
                          src={
                            product.image?.data
                              ? `data:${product.image?.contentType};base64,${product.image?.data}`
                              : "data:image/svg+xml;charset=UTF-8," +
                                encodeURIComponent(
                                  `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='260'><rect width='100%' height='100%' fill='#e2e8f0'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#64748b' font-family='Arial' font-size='14'>No image</text></svg>`
                                )
                          }
                          alt={product?.name ?? "Product image"}
                          className="w-full h-full object-contain select-none bg-slate-50"
                          loading="lazy"
                          decoding="async"
                          fetchpriority="low"
                          width={400}
                          height={260}
                          sizes="(max-width: 640px) 70vw, 100%"
                          onError={(e) => {
                            e.currentTarget.src =
                              "data:image/svg+xml;charset=UTF-8," +
                              encodeURIComponent(
                                `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='260'><rect width='100%' height='100%' fill='#e2e8f0'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#64748b' font-family='Arial' font-size='14'>Image unavailable</text></svg>`
                              );
                          }}
                        />
                      </div>

                      {/* text info */}
                      <div className="mt-1 space-y-0.5">
                        <h4 className="text-[13px] font-semibold text-sky-950 line-clamp-2 min-h-[2rem]">
                          {product?.name ?? "Product"}
                        </h4>

                        {product?.shortDescription && (
                          <p className="text-[11px] text-sky-700/80 line-clamp-2">
                            {product.shortDescription}
                          </p>
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="h-full w-full bg-slate-50 flex flex-col items-center justify-center text-slate-400 text-sm px-4 text-center">
                <p className="font-medium">No PowerPack products live yet.</p>
                <p className="mt-1 text-xs text-slate-500">
                  Once sellers upgrade visibility, their premium products will
                  appear here.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Onexvideo;
